export default "__VITE_ASSET__BlVoBKHJ__"